export default[
  {
  id:1234,
  category:"All Category",
 
   
},
    {

    id:0,
    img:"images/home.png",
    category:"Property",
    sub_category:[
      {
        id:121,
        category:"House & Apartments",
        sub_category:[
            {
              id:101,
              category:"For rent"
            },
            {
              id:102,
              category:"For Sale"
            }   
        
        
          ]
     
     
      },
      {
        id:122,
        category:"shops & office",
        sub_category:[
          {
            id:103,
            category:"Single Roome"
          },
          {
            id:104,
            category:"entire space"
          }  
      ]
      
      }
   ]
   },
   {
    id:1,
    img:"images/car.png",
    category:"cars",
    sub_category:[
      {
        id:120,
        category:"Hatchback",
      },
      {
        id:210,
        category:"Sedan",
      },
      {
        id:211,
        category:"MPV",
      },
      {
        id:212,
        category:"SUV",
      },
      {
        id:213,
        category:"SUV",
      },
      {
        id:214,
        category:"Gebrauchtwagen",
      },

   ] 
  
  },
   {
    id:2,
    img:"images/cycle.png",
    category:"Two wheelers",
    sub_category:[
      {
        id:221,
        category:"cycles",
        sub_category:[
            {
              id:221,
              category:"Gear cycles"
            },
            {
              id:222,
              category:"Roadster"
            }   
        
        
          ]
     
     
      },
      {
        id:222,
        category:"Bikes",
        sub_category:[
          {
            id:203,
            category:"Standard"
          },
          {
            id:204,
            category:"Sport"
          },
          {
            id:205,
            category:"Cruiser"
          }    
      ]
      
      },
      {
        id:342,
        category:"Scooters",
        sub_category:[
          {
            id:303,
            category:"Standard Scooters"
          },
          {
            id:304,
            category:"Electric Scooter"
          }   
      ]
      
      }

   ]

   },
   {
    id:3,
    img:"images/fashion.png",
    category:"Fashion & Beauty",
    sub_category:[
      {
        id:3034,
        category:"men",
        sub_category:[
          {
            id:30340,
            category:"Top wear"
          },
          {
            id:30341,
            category:"Bottom wear"
          },
          {
            id:30342,
            category:"Foot wear"
          }      
      ]
      },
      {
        id:3035,
        category:"Women",
        sub_category:[
          {
            id:30351,
            category:"Western"
          },
          {
            id:30352,
            category:"Tradition"
          },
          ]
      },
      {
        id:3036,
        category:"Kid",
        sub_category:[
          {
            id:30361,
            category:"Boys Clothing"
          },
          {
            id:30362,
            category:"girls Clothing"
          },
          ]
      }   
  ]


   },
   {
    id:4,
    img:"images/services.png",
    category:"jobs",
    
  },
   {
    id:5,
    img:"images/otherservice.png",
    category:"Other Services",
    sub_category:[
      {
        id:401,
        category:"Hiking"
      }
    ]
   },
   {
    id:6,
    img:"images/plug.png",
    category:"pets",
    sub_category:[
      {
        id:6034,
        category:"Buy pets",
        sub_category:[
          {
            id:60340,
            category:"cats"
          },
          {
            id:30341,
            category:"dogs"
          }
      ]
      },
      {
        id:6035,
        category:"Pets Asseroies",
        sub_category:[
          {
            id:60351,
            category:"Foods"
          },
          {
            id:60352,
            category:"Medicine"
          },
          ]
      },
      {
        id:6036,
        category:"Pets Supplies",
        sub_category:[
          {
            id:60361,
            category:"crates"
          },
        
          ]
      }   
  ]
 },
  
   {
    id:7,
    img:"images/plug.png",
    category:"Electronic & application",
    sub_category:[
      {
        id:7034,
        category:"Mobiles",
        sub_category:[
          {
            id:70340,
            category:"Smart phones"
          },
          {
            id:70341,
            category:"Normal"
          }
      ]
      },
      {
        id:7035,
        category:"Laptops",
        sub_category:[
          {
            id:70351,
            category:"Window"
          },
          {
            id:70352,
            category:"Mac"
          },
          ]
      },
      {
        id:7036,
        category:"Tablets",
        sub_category:[
          {
            id:70361,
            category:"Android"
          },
        
          ]
      }   
  ]
 }, 
   {
    id:8,
    img:"images/services.png",
    category:"services"
   },
   {
    id:9,
    img:"images/yourlogo.png",
    category:"car img"
   },
]